import { render, staticRenderFns } from "./AverageClicksPerVisitorChart.vue?vue&type=template&id=06667b4c"
import script from "./AverageClicksPerVisitorChart.vue?vue&type=script&lang=ts"
export * from "./AverageClicksPerVisitorChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports